exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.thumbnailContainer[data-v-37383c91]{padding:15px;width:100%;height:400px;overflow-y:scroll;display:flex;flex-wrap:wrap;justify-content:center;gap:15px\n}\n.thumbnail[data-v-37383c91]{max-width:200px;display:block;cursor:pointer\n}\n.thumbnail.selected[data-v-37383c91]{box-shadow:0 0 0 4px #4ea9dd;cursor:default\n}\n.thumbnail.changed[data-v-37383c91]{border:4px solid rgba(0,0,0,.54)\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-37383c91","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/mediaItem/MediaItemPosterSelector.vue
// module id = 199
// module chunks = 0